// 路由表：path → {feature, title, anyOf}（从 App.tsx 搬出，LeapWorldTwin-1214）。
// bun 测试加载不了 App.tsx（import.meta.glob 是 vite 构建期 API，运行时是 undefined），
// 路由守卫的断言需要这份纯数据，所以单独成文件。
// anyOf 与 features/shell/nav.ts 导航 NAV_GROUPS 的可见性保持一致；服务端仍有独立鉴权，前端守卫只做体验层。

import { CAPABILITIES, type Capability } from "../shared/capabilities";

interface RouteDef {
  path: string;
  /** src/features/<feature>/index.tsx 的目录名 */
  feature: string;
  /** 页面中文名（占位页展示用） */
  title: string;
  /** 任一能力命中可访问 */
  anyOf: Capability[];
}

export const ROUTE_TABLE: RouteDef[] = [
  { path: "/", feature: "dashboard", title: "工作台", anyOf: ["employee"] },
  { path: "/claims", feature: "claims", title: "申报中心", anyOf: ["employee"] },
  { path: "/approvals", feature: "approvals", title: "审批中心", anyOf: ["dept_head", "ops", "decide", "review", "verify", "admin"] },
  { path: "/booking", feature: "booking", title: "待入账", anyOf: ["ops"] },
  { path: "/dept-contribution", feature: "dept-contribution", title: "部门周期贡献", anyOf: ["dept_head", "ops", "admin"] },
  { path: "/projects", feature: "projects", title: "项目积分", anyOf: ["employee"] },
  { path: "/innovation", feature: "innovation", title: "创新成果", anyOf: ["employee"] },
  { path: "/contests", feature: "contests", title: "竞赛", anyOf: ["employee"] },
  { path: "/honors", feature: "honors", title: "荣誉表彰", anyOf: ["employee"] },
  { path: "/committee", feature: "committee", title: "委员积分", anyOf: ["employee"] },
  { path: "/adhoc", feature: "adhoc", title: "一事一议", anyOf: ["employee"] },
  { path: "/deductions", feature: "deductions", title: "违纪扣分", anyOf: ["dept_head", "ops", "decide", "verify", "admin"] },
  { path: "/redemptions", feature: "redemptions", title: "兑换中心", anyOf: ["employee"] },
  { path: "/ledger", feature: "ledger", title: "台账", anyOf: ["ops", "decide", "verify", "admin"] },
  { path: "/publicity", feature: "publicity", title: "公示", anyOf: ["employee"] },
  { path: "/ranking", feature: "ranking", title: "排行榜", anyOf: ["employee"] },
  { path: "/budget", feature: "budget", title: "预算总览", anyOf: ["ops", "decide", "verify", "admin"] },
  { path: "/admin", feature: "admin", title: "系统管理", anyOf: ["admin"] },
  { path: "/admin/agent-logs", feature: "agent-logs", title: "Agent 调用日志", anyOf: ["admin"] },
  { path: "/tools/api-keys", feature: "api-keys", title: "接入 Agent", anyOf: [...CAPABILITIES] },
  { path: "/account", feature: "account", title: "个人中心", anyOf: ["employee"] },
  // 入账方案确认（LeapWorldTwin-909）：不进主导航，入口是「待入账」待办和 Agent 返回的 confirmPath。
  // :planRef 参数由 react-router 解析，两条路由指向同一个功能目录，index.tsx 按 useParams 分流。
  { path: "/agent/plans", feature: "agent-plans", title: "入账方案确认", anyOf: ["ops"] },
  { path: "/agent/plans/:planRef", feature: "agent-plans", title: "入账方案确认", anyOf: ["ops"] },
];
